/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FAnonymousType112 } from './FAnonymousType112';
import {
    FAnonymousType112FromJSON,
    FAnonymousType112FromJSONTyped,
    FAnonymousType112ToJSON,
    FAnonymousType112ToJSONTyped,
} from './FAnonymousType112';

/**
 * 
 * @export
 * @interface FAnonymousType204
 */
export interface FAnonymousType204 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType204
     */
    id?: number;
    /**
     * 
     * @type {FAnonymousType112}
     * @memberof FAnonymousType204
     */
    definition?: FAnonymousType112;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType204
     */
    recording?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType204
     */
    data?: string | null;
}

/**
 * Check if a given object implements the FAnonymousType204 interface.
 */
export function instanceOfFAnonymousType204(value: object): value is FAnonymousType204 {
    return true;
}

export function FAnonymousType204FromJSON(json: any): FAnonymousType204 {
    return FAnonymousType204FromJSONTyped(json, false);
}

export function FAnonymousType204FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType204 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definition': json['definition'] == null ? undefined : FAnonymousType112FromJSON(json['definition']),
        'recording': json['recording'] == null ? undefined : json['recording'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function FAnonymousType204ToJSON(json: any): FAnonymousType204 {
    return FAnonymousType204ToJSONTyped(json, false);
}

export function FAnonymousType204ToJSONTyped(value?: FAnonymousType204 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definition': FAnonymousType112ToJSON(value['definition']),
        'recording': value['recording'],
        'data': value['data'],
    };
}

